<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import Select from '$components/Form/Select.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const materialsOptions = [
        `Ciment`,
        `Parpaing`,
        `Fer à béton`,
        `Tôles`,
        `Bois`,
        `Carrelage`,
        `Toiture`,
        `Étanchéité`,
        `Matériel`,
        `Autre (précisez)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const projectTypeOptions = [
        `Maison, appartement`,
        `Commercial`,
        `Industriel`,
        `Administration, association`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.materiauxConstruction.materials}
        class=""
        let:field
        let:id
        label={`Quels matériaux de construction recherchez-vous principalement ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 @[400px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={materialsOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.materiauxConstruction.projectType}
        class=""
        let:field
        let:id
        label={`Quel type de projet de construction ou de rénovation envisagez-vous ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={projectTypeOptions}
            placeholder="Sélectionnez un type de projet"
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
